import { useState, useEffect } from 'react';

function useMatchMedia(mediaQuery = `(max-width: 992px)`) {
  const [match, setMatch] = useState(window.matchMedia(mediaQuery).matches);

  useEffect(() => {
    const matchMedia = window.matchMedia(mediaQuery);

    const handleChange = () => {
      setMatch(window.matchMedia(mediaQuery).matches);
    };

    matchMedia.addListener(handleChange);

    return () => matchMedia.removeListener(handleChange);
  }, [mediaQuery]);

  return match;
}

export default useMatchMedia;
